/* The bag drawer's two additions (12 Oct 2026; canvas boards BagRecs, BagRecsSoft,
   BagRecsMobile, BagRecsWeekendMobile, DeliveryRules):

   1. The next-day delivery line, "Order within 2 hrs 40 mins and it ships today /
      Usually with you tomorrow, Tuesday 13 October, by Royal Mail Tracked 24", from
      assets/delivery-promise.js. UK bags only (GBP, English). It is worked out in the
      browser because it depends on the clock, and redrawn every 30 seconds while the
      bag is open. The slot ([data-delivery-promise]) sits in the free-delivery card
      that cart.js swaps in after every change, so it is refilled on each repaint.
   2. "You may also like": sections/calm-cart-recs.liquid through Shopify's product
      recommendations for the newest line in the bag, refetched only when the bag's
      products or total change. Add buttons go through window.OCAATCart.add, the same
      path as a product form (drawer refresh and add_to_cart analytics included).

   Both follow cart.js's 'ocaat:cart:painted' event. */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var I18N = window.OCAATCartI18n || {};
  var uk = I18N.currency === 'GBP' && I18N.locale === 'en';
  var recsBox = drawer.querySelector('[data-cart-recs]');

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- 1. delivery line ---- */
  function fillPromise() {
    var D = window.OcaatDelivery;
    if (!uk || !D) return;
    var slots = drawer.querySelectorAll('[data-delivery-promise]');
    if (!slots.length) return;
    var w;
    try { w = D.words(D.promise(new Date(), D.HOLIDAYS), true); } catch (e) { return; }
    var m = w.head.match(/^(Order within )(.+?)( and it ships .*)$/);
    var head = m ? esc(m[1]) + '<span class="cdlv__count">' + esc(m[2]) + '</span>' + esc(m[3]) : esc(w.head);
    slots.forEach(function (el) {
      var h = el.querySelector('.cdlv__h');
      var s = el.querySelector('.cdlv__s');
      if (h) h.innerHTML = head;
      if (s) s.textContent = w.sub;
      el.hidden = false;
    });
  }
  setInterval(function () {
    if (drawer.getAttribute('aria-hidden') === 'false') fillPromise();
  }, 30000);

  /* ---- 2. you may also like ---- */
  var lastKey = '';
  function loadRecs(cart) {
    if (!recsBox) return;
    if (!cart || !cart.item_count) { recsBox.innerHTML = ''; lastKey = ''; return; }
    var newest = cart.items[0];
    var key = newest.product_id + ':' + cart.items.map(function (i) { return i.product_id; }).join(',') + ':' + cart.total_price;
    if (key === lastKey) return;
    lastKey = key;
    var url = (I18N.root || '/') + 'recommendations/products?product_id=' + encodeURIComponent(newest.product_id) +
      '&limit=10&intent=related&section_id=calm-cart-recs';
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (key !== lastKey) return;            // a newer bag state got there first
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var inner = doc.querySelector('[data-recs-inner]');
        recsBox.innerHTML = inner ? inner.innerHTML : '';
      })
      .catch(function () { recsBox.innerHTML = ''; });
  }

  if (recsBox) {
    recsBox.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rec-add]');
      if (!btn || !window.OCAATCart || typeof window.OCAATCart.add !== 'function') return;
      e.preventDefault();
      btn.disabled = true;
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-rec-add'));
      fd.append('quantity', '1');
      window.OCAATCart.add(fd).then(function () { btn.disabled = false; });
    });
  }

  document.addEventListener('ocaat:cart:painted', function (e) {
    var cart = e.detail && e.detail.cart;
    fillPromise();
    loadRecs(cart);
  });
  fillPromise();
})();
